import Image from "@/components/AppImage";
import how_works_icon_2 from "/public/img/how-works-icon-2.png";

const HowItsWork = () => {
  return (
    <section className="how-works inner-how-works index7">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-7">
              <div className="section-header text-center">
                <h2 className="title">Activate the methods your clients prefer</h2>
                <p>
                  Pick the mix of rails you want to expose on each invoice—OracleMarket
                  handles compliance and settlement behind the scenes.
                </p>
              </div>
            </div>
          </div>
          <div className="row cus-mar">
            <div className="col-lg-4 col-md-4">
              <div className="single-item d-grid justify-content-center">
                <div className="icon">
                  <div className="iconbg">
                    <Image src={how_works_icon_2} alt="icon" />
                    <span className="xlr">01</span>
                  </div>
                </div>
                <div className="bottom-icon">
                  <h5>Select payout profile</h5>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="single-item second d-grid justify-content-center">
                <div className="icon">
                  <div className="iconbg">
                    <Image src={how_works_icon_2} alt="icon" />
                    <span className="xlr second">02</span>
                  </div>
                </div>
                <div className="bottom-icon">
                  <h5>Toggle payment rails</h5>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="single-item d-grid justify-content-center">
                <div className="icon">
                  <div className="iconbg">
                    <Image src={how_works_icon_2} alt="icon" />
                    <span className="xlr third">03</span>
                  </div>
                </div>
                <div className="bottom-icon">
                  <h5>Go live on invoices</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItsWork;
